import React from "react";
import { motion } from "framer-motion";

const Music = () => {
  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="category-header">
        <h2 className="main-title">Soundtrack of My Life 🎧</h2>
        <p className="subtitle" style={{ marginBottom: "30px" }}>
          Listen to my curated collection of favorite tracks.
        </p>
      </div>

      <div className="spotify-playlist-container" style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
        <iframe 
          data-testid="embed-iframe" 
          title="Spotify Playlist: Bia's Picks" // Penambahan properti title untuk menghilangkan warning
          style={{ borderRadius: "12px" }} 
          src="https://open.spotify.com/embed/playlist/2x5UEUQup6JPlzbYZAJmdb?utm_source=generator" 
          width="100%" 
          height="600" 
          frameBorder="0" 
          allowFullScreen={true} 
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
          loading="lazy"
        ></iframe>
      </div>
    </motion.div>
  );
};

export default Music;